import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { CARS_STATE } from '../../constants';

import { EBoxDashboardData, ObuNumber } from '../../types';

export const getCarEBoxDashboardData = createReduxAsyncThunk<EBoxDashboardData[], ObuNumber[]>(
  `${CARS_STATE}/getClientEBoxDashboardData`,
  async (obuSerialNumbers) => {
    const result = await Promise.allSettled(
      obuSerialNumbers.map((obuSerialNumber) => dataSources.cars.getCarEBoxDashboardData(obuSerialNumber))
    );

    return result.reduce((acc, item, index) => {
      if (item.status === 'fulfilled') {
        acc.push({
          // @ts-ignore
          ...item.value,
          obuNumber: obuSerialNumbers[index]
        });
      }
      
      return acc;
    }, [] as EBoxDashboardData[]);

  }
);
